module.exports = __webpack_public_path__ + "static/media/asm3.5e2afe57.jpg";